// eslint-disable-next-line import/prefer-default-export
export const UNLOAD_APP_EVENT = 'ud-app-loader.unload';
